import { type Components } from '@webapp/api/integrations/client'
import { IntegrationServicePlatforms } from '@webapp/models/enums'

export const getCurrentBusinessCentralEnvironment = (
  existingServiceIntegrations: Components.Schemas.IntegrationResponse[]
) => {
  if (!existingServiceIntegrations) {
    return IntegrationServicePlatforms.MERGE_DYNAMICS_365_BUSINESS_CENTRAL // Default for new setups
  }

  const hasCodatBusinessCentralIntegration = existingServiceIntegrations.some(
    (integration) =>
      integration.name ===
      IntegrationServicePlatforms.DYNAMICS_365_BUSINESS_CENTRAL
  )

  const hasMergeBusinessCentralIntegration = existingServiceIntegrations.some(
    (integration) =>
      integration.name ===
      IntegrationServicePlatforms.MERGE_DYNAMICS_365_BUSINESS_CENTRAL
  )

  if (
    !hasCodatBusinessCentralIntegration ||
    hasMergeBusinessCentralIntegration
  ) {
    return IntegrationServicePlatforms.MERGE_DYNAMICS_365_BUSINESS_CENTRAL
  }

  return IntegrationServicePlatforms.DYNAMICS_365_BUSINESS_CENTRAL
}
